import { render, staticRenderFns } from "./NewRecord.vue?vue&type=template&id=1e28baf6&scoped=true&"
import script from "./NewRecord.vue?vue&type=script&lang=js&"
export * from "./NewRecord.vue?vue&type=script&lang=js&"
import style0 from "./NewRecord.vue?vue&type=style&index=0&id=1e28baf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28baf6",
  null
  
)

export default component.exports